var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.emitterReportData,"server-items-length":_vm.total,"loading":_vm.reportTableLoading,"hide-default-footer":_vm.hideFooter,"options":_vm.options,"footer-props":_vm.getFooterProps()},on:{"update:options":function($event){_vm.options=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }